import { pl } from "date-fns/locale/pl";
import { uk } from "date-fns/locale/uk";
import type { Locale } from "date-fns";

export function isUkrainianLanguage(language: string | undefined): boolean {
  const code = (language ?? "").toLowerCase();
  return code === "ua" || code.startsWith("uk");
}

export function dateFnsLocaleFor(language: string | undefined): Locale {
  return isUkrainianLanguage(language) ? uk : pl;
}

export function intlLocaleFor(language: string | undefined): string {
  return isUkrainianLanguage(language) ? "uk-UA" : "pl-PL";
}
